import { Component, OnInit } from '@angular/core';
import { InvoiceService } from '../../Services/invoice.service';
import { ToastrService } from 'ngx-toastr';
import { InvoiceHistoryDate } from '../../Services/invoiceAddendumListViewModel';
import * as _ from 'lodash';
import * as moment from 'moment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ScreeningService } from 'src/app/screening-module/services/screening.service';
import { FileDownloadService } from 'src/app/services/file-download.service';

@Component({
  selector: 'app-email-monthly-accounting-report',
  templateUrl: './email-monthly-accounting-report.component.html',
  styleUrls: ['./email-monthly-accounting-report.component.less']
})
export class EmailMonthlyAccountingReportComponent implements OnInit {

  invoicingDates : InvoiceHistoryDate[] = [];
  invoicingYears : number[] = [];
  
  public get invoicingMonths() : number[] {
    if(!this.selectedYear) return [];
    return this.invoicingDates.filter(id => {return id.year == this.selectedYear}).map(id => {return id.month}).sort((a, b) => {
      if (a < b) return -1;
      if (a > b) return 1;
      return 0;
    });;

  }
  
  selectedYear : number;
  selectedMonth : number;
  constructor(private invoiceSrv : InvoiceService, 
    private toastr : ToastrService,
    private fileDownload : FileDownloadService,
    public readonly modalService: NgbModal) { }

  ngOnInit() {
    this.invoiceSrv.getInvoiceHistoryMonthAndYears().subscribe(
      (scc:any)=>{
        scc.forEach(element => {
          this.invoicingDates.push(new InvoiceHistoryDate(element));
        });
        this.invoicingYears = _.uniq(this.invoicingDates.map(id=>{return id.year})).sort((a, b) => {
          if (a < b) return -1;
          if (a > b) return 1;
          return 0;
        });
      },
      (err:any)=>{
        this.toastr.error('Please Contact development for assistance','Error Loading Invoice History')
      })
  }

  getMonthName(month:number): string{
    return moment().month(month -1).format('MMMM');
  }

  save(){
    this.invoiceSrv.downloadAccountingReport(this.selectedMonth,this.selectedYear).subscribe((scc:Blob)=>{
      this.fileDownload.HandleFileDownload(scc,'text/csv', `WRT_RIQ_Invoicing_${this.selectedYear}-${this.selectedMonth}.csv`);
      this.modalService.dismissAll();
    })
  }

}
